import type { ReactNode } from 'react';

/** A page's title and its one-line explanation, with room for an action. */
export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string;
  /** Prose, and occasionally a `<code>` in it: a command somebody has to type. */
  description?: ReactNode;
  actions?: ReactNode;
}): ReactNode {
  return (
    <header className="page-header">
      <div>
        <h1>{title}</h1>
        {description !== undefined && <p>{description}</p>}
      </div>
      {actions !== undefined && <div className="row">{actions}</div>}
    </header>
  );
}
